// authorize.js

const Authorize = store => {
  // Add $authorize instance method directly to Store modules
  store.$authorize = (action, subject) => {
    if (Vue.$can(action, subject)) return true

    throw new Error('Forbidden')
    return false
  }
}

export default Authorize
